import { Apis, Labels } from '../../app.constants';
import SweetAlert from '../../../components/Shared/Notification';
import APIService from '../../APIService';

const ReportActions = () => {
  const getReportTemplates = async (leadFormId, publishedOnly) => {
    try {
      const res = await APIService.get(
        `${Apis.getReportTemplate}?leads_form_id=${leadFormId}&published_only=${publishedOnly}`
      );
      return res;
    } catch (error) {
      return error;
    }
  };

  const getHtmlPreview = async (leadFormId, payload) => {
    try {
      const res = await APIService.post(`${Apis.htmlPreview}${leadFormId}/`, payload);
      return res;
    } catch (error) {
      SweetAlert('Failed to fetch html preview', 'error');
      return error;
    }
  };

  const deleteReport = async (templateId) => {
    try {
      const res = await APIService.remove(`${Apis.deleteReport}${templateId}`);
      return res;
    } catch (error) {
      return error;
    }
  };

  const getReportTemplateDetails = async (templateId) => {
    if (!templateId) {
      return null;
    }
    try {
      const res = await APIService.get(`${Apis.getTemplate}${templateId}`);
      return res;
    } catch (error) {
      return error;
    }
  };

  const updateReportTemplate = async (templateId, payload) => {
    if (!templateId) return { status: 400, data: { message: 'Template ID required' } };
    try {
      const res = await APIService.put(`${Apis.updateReport}${templateId}`, payload);
      return res;
    } catch (error) {
      SweetAlert('Failed to update report template', 'error');
      return error?.response ?? { status: 500, data: { message: 'Network/Server error' } };
    }
  };

  const generateReportTemplates = async (payload) => {
    try {
      const res = await APIService.post(`${Apis.generateReport}report-templates/`, payload);
      return res;
    } catch (error) {
      return error;
    }
  };

  const generateQuickReport = async (payload) => {
    try {
      const res = await APIService.post(`${Apis.generateReport}reports/quick`, payload);
      return res;
    } catch (error) {
      return error;
    }
  };

  const getSchemaHelper = async (payload) => {
    try {
      const res = await APIService.post(`${Apis.generateReport}schema-helper`, payload);
      return res;
    } catch (error) {
      SweetAlert('Failed to load schema helper', 'error');
      return error;
    }
  };

  const getReportAnalysis = async (leadFormId) => {
    try {
      const res = await APIService.get(
        `${Apis.generateReport}reports/generated?leads_form_id=${leadFormId}&limit=20`
      );
      return res;
    } catch (error) {
      SweetAlert('Failed to fetch report analysis', 'error');
      return error;
    }
  };

  const getScheduleOptions = async () => {
    try {
      const res = await APIService.get(Apis.scheduleOptions);
      return res;
    } catch (error) {
      SweetAlert('Failed to load schedule options', 'error');
      return error;
    }
  };

  const createTemplateTrigger = async (templateId, payload) => {
    if (!templateId) return { status: 400, data: { message: 'Template ID required' } };
    try {
      const url = `${Apis.templateTriggers}${templateId}/triggers/`;
      const res = await APIService.post(url, payload);
      return res;
    } catch (error) {
      SweetAlert('Failed to create trigger', 'error');
      return error?.response ?? { status: 500, data: { message: 'Network/Server error' } };
    }
  };

  const getTemplateTriggers = async (templateId) => {
    if (!templateId) return { status: 400, data: { message: 'Template ID required' } };
    try {
      const url = `${Apis.templateTriggers}${templateId}/triggers/`;
      const res = await APIService.get(url);
      return res;
    } catch (error) {
      SweetAlert('Failed to fetch triggers', 'error');
      return error?.response ?? { status: 500, data: { message: 'Network/Server error' } };
    }
  };

  const updateTemplateTrigger = async (templateId, triggerId, payload) => {
    if (!templateId || !triggerId) {
      return { status: 400, data: { message: 'Template ID and Trigger ID required' } };
    }
    try {
      const url = `${Apis.templateTriggers}${templateId}/triggers/${triggerId}/`;
      const res = await APIService.put(url, payload);
      return res;
    } catch (error) {
      SweetAlert('Failed to update trigger', 'error');
      return error?.response ?? { status: 500, data: { message: 'Network/Server error' } };
    }
  };

  return {
    getReportTemplates,
    getHtmlPreview,
    deleteReport,
    getReportTemplateDetails,
    updateReportTemplate,
    generateReportTemplates,
    generateQuickReport,
    getSchemaHelper,
    getReportAnalysis,
    getScheduleOptions,
    createTemplateTrigger,
    getTemplateTriggers,
    updateTemplateTrigger,
  };
};
export { ReportActions };
